import React from "react";
import {
  ButtonContainer,
  CancelButton,
  ConfirmButton,
  ContentContainer,
  IconContainer,
  Message,
  ModalContainer,
  Overlay,
  Title,
} from "./alertModal.styled";

interface AlertModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  variant?: "warning" | "danger" | "info";
}

const AlertTriangle = ({ size = 64 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z" />
      <path d="M12 9v4" />
      <path d="m12 17 .01 0" />
    </svg>
  );
};

export const AlertModal: React.FC<AlertModalProps> = (props) => {
  if (!props.isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      props.onCancel();
    }
  };

  return (
    <Overlay onClick={handleOverlayClick}>
      <ModalContainer>
        <IconContainer variant={props.variant ? props.variant : "info"}>
          <AlertTriangle size={64} />
        </IconContainer>

        <ContentContainer>
          <Title>{props.title}</Title>
          <Message>{props.message}</Message>
        </ContentContainer>

        <ButtonContainer>
          <CancelButton onClick={props.onCancel}>
            {props.cancelText}
          </CancelButton>
          <ConfirmButton
            onClick={props.onConfirm}
            variant={props.variant ? props.variant : "info"}
          >
            {props.confirmText}
          </ConfirmButton>
        </ButtonContainer>
      </ModalContainer>
    </Overlay>
  );
};
